import {useQuery} from '@tanstack/react-query';
import axios, {AxiosError} from 'axios';
import {ListInvitationsResponse} from '../Types/invitationTypes';
import {INVITATIONS_QUERY_KEY} from '../Shared/invitationQueryKeys';

const useListInvitations = () => {
  const {data, isLoading, error, refetch} = useQuery<ListInvitationsResponse, AxiosError>({
    queryKey: INVITATIONS_QUERY_KEY,
    queryFn: () => axios.get('/api/invitations').then((res) => res.data),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  return {data, isLoading, error, refetch};
};

export default useListInvitations;
